import { useQueryClient } from '@tanstack/react-query'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useDeleteNotifications = () => {
  const queryClient = useQueryClient()

  const mutation = useApiMutation(
    'schools',
    ({ notificationId }) => `/notifications/${notificationId}`,
    'delete',
    {
      onSuccess: (_, variables) => {
        const { ids = [] } = variables

        queryClient.setQueryData(['bup-modes-notifications'], previous => {
          if (!Array.isArray(previous) || ids.length === 0) return previous
          return previous.filter(notification => !ids.includes(notification.id))
        })
        queryClient.invalidateQueries(['bup-modes-notifications'])
      }
    },
    { authenticated: true, version: 3 }
  )

  return {
    deleteNotification: (notificationIds = []) => {
      const ids = Array.isArray(notificationIds) ? notificationIds : [notificationIds]
      if (ids.length === 0) return Promise.resolve([])
      return Promise.all(
        ids.map(notificationId =>
          mutation.mutateAsync({ notificationId, ids })
        )
      )
    },
    isDeletingNotifications: mutation.isPending
  }
}
